import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  BehaviorSubject,
  Observable,
  Subject,
  catchError,
  debounceTime,
  filter,
  map,
  of,
  switchMap,
  tap,
} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private http = inject(HttpClient);
  activateRoute = inject(ActivatedRoute);

  public searchKeyworld = new BehaviorSubject('');
  public searchByAnswer = new BehaviorSubject(false);
  public searching = new BehaviorSubject(false);
  public searchCategory = new Subject();
  public checkedCategory = new BehaviorSubject('');

  searchResult$: Observable<any> = this.searchKeyworld.pipe(
    debounceTime(600),
    filter((term) => term.length > 2),
    tap(() => {
      console.log('search service called ');
      this.searching.next(true);
    }),
    switchMap((term) =>
      this.search({ search: term, type: '', answer: this.searchByAnswer.value }).pipe(
        catchError((err) => of(null)),
        tap(() => this.searching.next(false))
      )
    )
  );
  public search(payload: any, limit = 0): Observable<any> {
    return this.http.post('/api/search/v1/get/search?limit=' + limit, payload);
  }

  checkKeyword(term: string) {
    return this.searchKeyworld.value === term;
  }
  getCheckedCategory() {
    return this.checkedCategory.value;
  }
  setCheckedCategory(category: string) {
    this.checkedCategory.next(category);
  }
}
